import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import Home from './components/Luckysheet';
import Hutang_Customer from './components/Hutang_Customer';
import Marking from './components/Marking';
import Karyawan from './components/Karyawan';
import Kasbon from './components/Kasbon';
import Kasbonp from './components/Kasbonp';
import DocumentUpload from './components/DocumentUpload';
import DocumentUploadBiaya from "./components/DocumentUploadBiaya";
import MasterUser from "./components/MasterUser";
import Pph21 from "./components/Pph21";
import CfgBpjs from "./components/ConfigBpjs";
import Expense from './components/Expense';
import Thegodfather from './components/Thegodfather';
import Piutang from './components/Piutang';
import Asset from './components/Asset';
import ReportToko from './components/ReportToko';
import Jurnal from './components/Jurnal';
import DataInOut from './components/DataInOut';
import DataInOutUSD from './components/DataInOutUSD';
import KasUSD from './components/KasUSD';
import KasUSD_Rek from './components/KasUSD_Rek';
import Akuran from './components/Akuran';
import Omset from './components/Omset';
import Omset_aktual from './components/Omset_aktual';
import Omset_aktualT from './components/Omset_aktualT';
import Omset_kasaran from './components/Omset_kasaran';
import Persen_fr from './components/Persen_FR';
import ReportKPS from './components/ReportKPS';
// import ReportUSD from './components/ReportUSD';
import ReportIdrUSD from './components/ReportIdrUSD';
import ReportAllDivision from './components/ReportAllDivision';
import ReportAllDivisionReview from './components/ReportAllDivisionReview';
import ReportCross from './components/ReportCross';
import ReportOmset from './components/ReportOmset';
import Asset_setting from './components/Asset_setting';
import GoogleSearch from './components/GoogleSearch';
import User_c_pass from './components/User_c_pass';
import Logout from './components/Logout';
import { useAuth } from "./AuthContext";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, path }: { element: JSX.Element; path: string }) => {
  const isTrue  = useAuth();

  if (!isTrue) {
    return <Navigate to="/" />;
  }
  return element;
};
const App: React.FC = () => {

  return (
    <Router >
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/karyawan/:param1/:param2" element={<Karyawan />} />
          <Route path="/kasbon/" element={<Kasbon />} />
          <Route path="/kasbonp/" element={<Kasbonp />} />
          <Route path="/expense/:param1/:param2" element={<Expense />} />
          <Route path="/thegodfather" element={<Thegodfather />} />
          <Route path="/piutang/:param1/:param2" element={<Piutang />} />
          <Route path="/omset/:param1/:param2" element={<Omset />} />
          <Route path="/DataInOut/:param1/:param2" element={<DataInOut />} />
          <Route path="/DataInOutUSD/:param1/:param2" element={<DataInOutUSD />} />
          <Route path="/KasUSD/:param1/:param2" element={<KasUSD />} />
          <Route path="/Karyawan" element={<Karyawan />} />
          <Route path="/Rekening_Kas_USD/:param1/:param2" element={<KasUSD_Rek />} />
          <Route path="/Akuran/:param1/:param2" element={<Akuran />} />
          <Route path="/Omset_aktual/:param1/:param2" element={<Omset_aktual />} />
          <Route path="/Omset_aktualT/:param1/:param2" element={<Omset_aktualT />} />
          <Route path="/Omset_kasaran/:param1/:param2" element={<Omset_kasaran />} />
          <Route path="/Persen_fr/:param1/:param2" element={<Persen_fr />} />
          <Route path="/asset" element={<Asset />} />
          <Route path="/ReportToko" element={<ReportToko />} />
          <Route path="/ReportKPS" element={<ReportKPS />} />
          {/* <Route path="/ReportUSD" element={<ReportUSD />} /> */}
          <Route path="/ReportAllDivision" element={<ReportAllDivision />} />
          <Route path="/ReportAllDivisionReview" element={<ReportAllDivisionReview />} />
          <Route path="/ReportCross" element={<ReportCross />} />
          <Route path="/ReportIdrUSD" element={<ReportIdrUSD />} />
          <Route path="/ReportOmset" element={<ProtectedRoute element={<ReportOmset />} path="ReportOmset" />} />
          <Route path="/Jurnal" element={<Jurnal />} />
          <Route path="/AssetSetting" element={<Asset_setting />} />
          <Route path="/GoogleSearch" element={<GoogleSearch />} />
          <Route path="/User_change_pass" element={<User_c_pass />} />
          <Route path="/Logout" element={<Logout />} />
          {/* <Route path="/DocumentUpload" element={<DocumentUpload/>} />
          <Route path="/DocumentUploadBiaya" element={<DocumentUploadBiaya/>} /> */}
          {/* <Route path="/User" element={<MasterUser/>} /> */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;
